(function () {
  function showObfuscatedEmail() {
    var elements = document.querySelectorAll('.email-obfuscated');

    elements.forEach(function (element) {
      var email = [
        'antikhalle',
        '-dresden',
        '@',
        'gmx',
        '.de'
      ].join('');

      var link = document.createElement('a');
      link.href = 'mailto:' + email;
      link.textContent = email;

      element.replaceWith(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showObfuscatedEmail);
  } else {
    showObfuscatedEmail();
  }
})();